import type { z } from 'zod'
import type { LowerHex, TransactionDecoded } from '../../../../types'
import { getAllValue } from './allValue'
import type { arrayInSchema } from './schema'

export const checkValueIsArrayIn = ({
  value,
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly value: string
  readonly schema: z.infer<typeof arrayInSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): boolean => {
  const valuesSet = getArrayInValues({
    schema,
    transaction,
    relatedAddresses,
  })
  if (schema.not === true) {
    return !valuesSet.has(value)
  }
  return valuesSet.has(value)
}

const getArrayInValues = ({
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly schema: z.infer<typeof arrayInSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): Set<string> => {
  const set = new Set<string>()

  for (const value of schema.values) {
    // related
    if (value === 'related') {
      for (const address of relatedAddresses) {
        set.add(address)
      }
      continue
    }
    // all value
    set.add(getAllValue({ schema: value, transaction, relatedAddresses }))
  }
  return set
}
